(function init() {
  angular.module('app').controller('host.views.debugTools.completeHubPatientSession.modal', [
    '$uibModalInstance',
    'abp.services.app.debugTool',
    function controller($uibModalInstance, debugToolSvc) {
      const vm = this;
      vm.saving = 0;

      vm.cancel = cancel;
      vm.confirm = confirm;

      vm.guaranteeLetterNumber = '';

      function cancel() {
        $uibModalInstance.dismiss();
      }

      function confirm() {
        vm.saving += 1;

        debugToolSvc
          .completeHubPatientSession({ letterNumber: vm.guaranteeLetterNumber })
          .success(() => {
            abp.notify.info('Completed Hub Patient Session');
          })
          .finally(() => {
            vm.saving -= 1;
            vm.guaranteeLetterNumber = '';
          });
      }
    },
  ]);
})();
